export const ABBR_TO_DIGITS_PRICE_MAP = {
    млн: '000 000',
    'млн.': '000 000',
    тыс: '000',
    'тыс.': '000',
};
